var React = require('react');

function FileCheck (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 128H272a16 16 0 0 1-16-16V0H24A23.94 23.94 0 0 0 0 23.88V488a23.94 23.94 0 0 0 23.88 24H360a23.94 23.94 0 0 0 24-23.88V128zm-70.7 158.67l-143 141.81a12 12 0 0 1-17 0l-82.6-83.31a12 12 0 0 1 .07-17L99.17 300a12 12 0 0 1 17 0l46 46.35 106-105.18a12 12 0 0 1 17 0l28.17 28.4a12 12 0 0 1-.04 17.1z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M285.17 241.3a12 12 0 0 0-17 0l-106 105.18-46-46.35a12 12 0 0 0-17 0l-28.4 28.2a12 12 0 0 0-.07 17l82.57 83.27a12 12 0 0 0 17 0l143-141.81a12 12 0 0 0 0-17zM377 105L279.1 7a24 24 0 0 0-17-7H256v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9z","className":"fa-primary","key":2})]);
}

FileCheck.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = FileCheck;

FileCheck.default = FileCheck;
